import { createSelector } from '@reduxjs/toolkit';
import selectSsoRaw from './selectSsoRaw';

export default createSelector(selectSsoRaw, (sso) => sso?.error);
